import {AdminRuntimeOverridableKeys} from '../constants/AdminRuntimeOverridableKeys'
import {IAdminRuntimeEnvOverrides} from '../types/IAdminRuntimeEnvOverrides'

export function pickOverridableFromEnv(): IAdminRuntimeEnvOverrides {
  const result: IAdminRuntimeEnvOverrides = {}
  for(const key of AdminRuntimeOverridableKeys) {
    ;(result as Record<string, unknown>)[key] = ENV[key]
  }
  return result
}
